const {
    REACT_APP_MASTER_LAWYER_DEV_BASE_URL:MASTER_LAWYER_DEV_BASE_URL,
}=process.env;

const MASTER_BASE_URL = MASTER_LAWYER_DEV_BASE_URL || '';

export const LAWYERMANAGEMENT=`${MASTER_BASE_URL}lawyer`;
export const CUSTOMERMANAGEMENT=`${MASTER_BASE_URL}customer`;
export const CONFIGMASTER=`${MASTER_BASE_URL}config`;
export const REQUESTMANAGEMENT=`${MASTER_BASE_URL}requests`;
export const USERMANAGEMENT=`${MASTER_BASE_URL}user`;
export const ADMINUSERMANAGEMENT=`${MASTER_BASE_URL}adminUser`;
export const OTP_SERVICE=`${MASTER_BASE_URL}whatsapp`;
export const USERADMIN=`${MASTER_BASE_URL}adminUser`;
export const CONSULTATION=`${MASTER_BASE_URL}consultations`;
export const COMPLAINTS=`${MASTER_BASE_URL}complaints`;
export const SENDMESSAGEWHATSAPP=`${MASTER_BASE_URL}whatsapp/warning-message`;
export const SENDMESSAGEMAILID=`${MASTER_BASE_URL}mail/send-warning`;
export const CONFIGMANAGEMENT=`${MASTER_BASE_URL}config`;
export const SUPPORTMANAGEMENT=`${MASTER_BASE_URL}support`;
export const FEEDBACKMANAGEMENT=`${MASTER_BASE_URL}feedback`;
export const SENDMESSAGEWHATSAPPSUPPORT=`${MASTER_BASE_URL}whatsapp/send-support`;
export const SENDMESSAGEMAILSUPPORT=`${MASTER_BASE_URL}mail/send-support`;
export const TRANSACTIONMANAGEMENT=`${MASTER_BASE_URL}transaction`;
export const PAYMENTMANAGEMENT=`${MASTER_BASE_URL}payments`;
export const COUPONMANAGEMENT=`${MASTER_BASE_URL}coupon`;
export const DISCOUNTMANAGEMENT=`${MASTER_BASE_URL}discount`;
export const ACCESSCONTROLMANAGEMENT=`${MASTER_BASE_URL}access-controls`;
export const ACCOUNT_DETAILS=`${MASTER_BASE_URL}account_details`;
